export default "__VITE_ASSET__59171977__"